import { apiClient } from '../../../api/client';
import type {
  ExecutionHistory,
  ActivityInstancesResponse,
  BpmnDefinition,
  DeployBpmnRequest,
  ValidateBpmnResponse,
  ProcessDefinitionWithOwnership,
  CreateProcessDefinitionRequest,
  CopyTemplateRequest,
  CopyTemplateResponse,
} from '../types/bpmn.types';

export const bpmnApi = {
  // BPMN XML
  getProcessDefinitionXml: (key: string) =>
    apiClient.getText(`/processes/definitions/${key}/xml`),

  // Execution History
  getExecutionHistory: (processInstanceId: string) =>
    apiClient.get<ExecutionHistory>(`/processes/${processInstanceId}/execution-history`),

  getActiveActivityInstances: (processInstanceId: string) =>
    apiClient.get<ActivityInstancesResponse>(
      `/processes/${processInstanceId}/activity-instances`
    ),

  // Process Variables
  updateProcessVariables: (processInstanceId: string, variables: Record<string, unknown>) =>
    apiClient.put<void>(`/processes/${processInstanceId}/variables`, variables),

  // BPMN Definition Management (Admin)
  getDefinitions: () => apiClient.get<BpmnDefinition[]>('/bpmn/definitions'),

  deployDefinition: (request: DeployBpmnRequest) =>
    apiClient.post<BpmnDefinition>('/bpmn/definitions', request),

  updateDefinition: (key: string, xml: string) =>
    apiClient.put<BpmnDefinition>(`/bpmn/definitions/${key}`, { xml }),

  deleteDeployment: (deploymentId: string) =>
    apiClient.delete<void>(`/bpmn/definitions/${deploymentId}`),

  validateBpmn: (xml: string) =>
    apiClient.post<ValidateBpmnResponse>('/bpmn/definitions/validate', { xml }),

  // Task Reassignment
  reassignTask: (taskId: string, assignee: string) =>
    apiClient.post<void>(`/tasks/${taskId}/reassign`, { assignee }),

  // Authority-specific Process Definition Management
  getMyDefinitions: (keyId: string) =>
    apiClient.get<ProcessDefinitionWithOwnership[]>('/bpmn/definitions/my', {
      headers: { 'X-Key-Id': keyId },
    }),

  getTemplates: () =>
    apiClient.get<ProcessDefinitionWithOwnership[]>('/bpmn/definitions/templates'),

  createMyDefinition: (keyId: string, request: CreateProcessDefinitionRequest) =>
    apiClient.post<ProcessDefinitionWithOwnership>('/bpmn/definitions/my', request, {
      headers: { 'X-Key-Id': keyId },
    }),

  copyTemplate: (templateKey: string, keyId: string, request: CopyTemplateRequest) =>
    apiClient.post<CopyTemplateResponse>(`/bpmn/definitions/${templateKey}/copy`, request, {
      headers: { 'X-Key-Id': keyId },
    }),

  updateMyDefinition: (keyId: string, key: string, xml: string) =>
    apiClient.put<ProcessDefinitionWithOwnership>(`/bpmn/definitions/my/${key}`, { xml }, {
      headers: { 'X-Key-Id': keyId },
    }),

  deleteMyDefinition: (keyId: string, key: string) =>
    apiClient.delete<void>(`/bpmn/definitions/my/${key}`, {
      headers: { 'X-Key-Id': keyId },
    }),

  getDefinitionWithOwnership: (key: string) =>
    apiClient.get<ProcessDefinitionWithOwnership>(`/bpmn/definitions/${key}/ownership`),
};
